import React from 'react';
import SupplierMetersIndexPage from '../supplier_meters_index_page/SupplierMetersIndexPage';

export default function SupplierMetersArchivedIndexPage() {
	return (
		<SupplierMetersIndexPage
			preAppliedFilters={{ isArchived: 'true' }}
			targetCollectionName="archivedMetersIndex"
		/>
	);
}
